<template>
    <a-card :bordered="false" class="widget-1" :headStyle="{ height:'48px'}" :bodyStyle="{ paddingLeft: '8px',  paddingRight: '8px',  paddingTop: '10px', paddingBottom: '5px'}">
        <a-flex gap="middle" align="center" justify="space-between">
            <a-button type="primary" size="medium" @click="filterInvoicesperService">VER FACTURAS ASOCIADAS</a-button>
            <a-button size="medium" :danger="route.meta.myCliente[0].credit > 0">{{ msgService() }}</a-button>
        </a-flex>
    </a-card>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { TitleServiceCut } from '@/plugins/odoo_table'
const route = useRoute(); 
const msgService = () => {
    if (route.meta.myCliente[0].credit <= 0) {
        return "ABONAR CREDITO"
    } else {
        return "PAGAR DEUDA"
    }
}
const props = defineProps(
    {
        my_service: {
            type: Object,
            required: true
        }
    }
)
const filterInvoicesperService = () => {
    console.log(props.my_service)
    const filterInvoices = ref(null)
    if (!route.meta.invoices) {
        // procedimiento para cargar lista completa de invoices
    }
    filterInvoices.value = route.meta.invoices.map( (item) => {
        const serviceFound =  TitleServiceCut(props.my_service.display_name)[1]
        const findServiceInvoice = item.lines.find( lineInvoice => lineInvoice == serviceFound)
        console.log(findServiceInvoice)
    })
    console.log(filterInvoices)
    return filterInvoices.value
}
onMounted(() => {
 console.log(route.meta.myCliente[0])
})
</script>